exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-split[data-v-c2ce4fb8]{height:100%}.demo-split-pane[data-v-c2ce4fb8]{padding:10px;width:50%;float:left}.named[data-v-c2ce4fb8]{width:150px;float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-c2ce4fb8","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dialysisProcess/waitRoom/conEdit.vue
// module id = h/ds
// module chunks = 0